import React from "react";
import { SuccessIcon } from "../../assets/icons";

const SuccessSideBar = ({ visible, onClose, closeCreate, project = false, client = false, from, resetForm }) => {
  if (!visible) return null;

  const BacktoView = () => {
    onClose();
    closeCreate();
  };

  const handleCreateMore = () => {
    onClose();
    resetForm();
  };

  const getSuccessMessage = () => {
    if (client) return "Client Successfully Created";
    if (project) return "Project Successfully Assigned";
    return "Task Successfully Created";
  };

  const getCreateMoreMessage = () => {
    if (client) return null; // No "Create More" for clients
    if (project) return "Assign more projects";
    return "Create more tasks";
  };

  const getBackMessage = () => {
    if (client) return "Back to project";
    if (project) return "Back to worker detail";
    if(from=="createProject") return "Back to task list";
    if(from=='projectDetail') return "Back to project detail";
    if(from=='taskList') return "Back to task list";
    return "Back to add project";
  };

  return (
    <div style={{zIndex:99999999}} className="fixed top-0 right-0 w-[400px] h-full bg-white shadow-lg z-50" onClick={onClose}>
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="absolute top-0 right-0 w-[400px] h-full bg-white shadow-lg" onClick={(e) => e.stopPropagation()}>
      <div className="p-6 flex flex-col items-center justify-start gap-5 h-full">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <span className="text-xl font-bold">&times;</span>
        </button>
        <div className="flex flex-col items-center mt-16">
          <span>{SuccessIcon}</span>
          <p className="text-[20px] font-semibold mt-4 text-[#1E3A8A]">
            {getSuccessMessage()}
          </p>
        </div>
        <div className="space-y-4 w-full flex flex-col justify-center items-center">
          {getCreateMoreMessage() && (
            <button
              className="bg-[#F97316] w-[60%] hover:bg-orange-600 text-white py-2 px-4 rounded"
              onClick={handleCreateMore}
            >
              {getCreateMoreMessage()}
            </button>
          )}

          <button
            className="text-[#F97316] hover:underline w-full py-2"
            onClick={BacktoView}
          >
            {getBackMessage()}
          </button>
        </div>
      </div>
      </div>
    </div>
  );
};

export default SuccessSideBar;
